import { useMemo } from 'react';
import { formatLabel, getMetricColor } from '../utils/chartHelpers';
import { CHART_CONFIG } from '../utils/constants';

const useChartData = (metrics, isComparisonMode) => {
  const chartData = useMemo(() => {
    return metrics.map((metric) => {
      const color = getMetricColor(metric.label);
      const formattedName = formatLabel(metric.label);

      if (isComparisonMode) {
        // In comparison mode, use real baseline/followup data from API
        const baselineCount = metric.baselineCount || Math.floor(metric.count * CHART_CONFIG.BASELINE_MOCK_MULTIPLIER);
        const followupCount = metric.followupCount || metric.count;

        return {
          name: formattedName,
          fullName: metric.label,
          baseline: baselineCount,
          followup: followupCount,
          baselinePercent: metric.baselinePercent || Math.round((baselineCount / CHART_CONFIG.TOTAL_POPULATION) * 100),
          followupPercent: metric.followupPercent || metric.percent,
          color: color,
          originalMetric: metric,
        };
      } else {
        return {
          name: formattedName,
          fullName: metric.label,
          value: metric.count,
          percent: metric.percent,
          color: color,
          originalMetric: metric,
        };
      }
    });
  }, [metrics, isComparisonMode]);

  return chartData;
};

export default useChartData;
